import React from 'react'
import { ShopfloImageDomain } from 'src/lib/utils/constants'
import ColorPickerV2 from '../common/ColorPickerV2'
import { useCartContext } from 'src/lib/contexts/CartContext'
import { CartElements } from './CartElements'
import { CartScrollableElements } from './CartScrollableElements'

export const CartControls = () => {
  return (
    <>
      <div className='px-6 py-4 flex justify-between items-center sticky top-0 bg-white z-10'>
        <h3 className='text-text-sm-semibold text-zinc-800'>Layout</h3>
        <div className='flex gap-1 items-center'>
          <div className='w-5 h-5'>
            <img src={`${ShopfloImageDomain}/cart-design.svg`} alt='Cart' className='w-full h-full object-contain' />
          </div>
          <h4 className='text-text-sm-semibold text-zinc-600'>Quick Styles</h4>
        </div>
      </div>
      <div className='flex flex-col px-6 pb-4'>
        <CartLayoutWrapper />
      </div>
      <hr className='border-0 h-px bg-zinc-950/5 mt-1' />
      <div className='px-6 py-4'>
        <h3 className='text-text-sm-semibold text-zinc-800'>Elements</h3>
      </div>
      <div className='px-2'>
        <CartElements />
        <hr className='border-0 h-px bg-zinc-950/5 my-2' />
        <CartScrollableElements />
      </div>
    </>
  )
}

export const CartLayoutWrapper = () => {
  const {
    getters: { cartUIData },
    actions: { setCartUIConfigData }
  } = useCartContext()
  return (
    <div className='flex flex-col'>
      <ColorPickerV2
        label='Cart Background'
        color={cartUIData.page.backgroundColor}
        onChange={color => setCartUIConfigData({ backgroundColor: color }, 'LAYOUT')}
      />
    </div>
  )
}
